/* ============================================================
   MAS & LOLLY — Shopify Theme JS
   ============================================================ */
(function () {
  'use strict';

  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));
  const ROUTES = window.routes || {};

  // -------- Locale helper --------
  // Detects current locale from the URL (e.g. /ar/collections/... → 'ar')
  // and prepends it to any internal path so navigation stays in the same language.
  const _localeMatch = window.location.pathname.match(/^\/([a-z]{2})(?:\/|$)/);
  const _locale = _localeMatch ? _localeMatch[1] : null;
  // Returns path with locale prefix when needed, e.g. localePath('/collections/all') → '/ar/collections/all'
  function localePath(path) {
    if (!_locale) return path;                          // English (no prefix)
    if (path.startsWith('/' + _locale + '/') || path === '/' + _locale) return path; // already prefixed
    return '/' + _locale + (path.startsWith('/') ? path : '/' + path);
  }

  // -------- Money formatter --------
  function formatMoney(cents) {
    const value = (cents / 100).toFixed(2).replace(/\.00$/, '');
    const fmt = window.moneyFormat || 'EGP {{amount}}';
    return fmt.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/, value)
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  }

  // -------- Cart drawer --------
  const drawer = $('#drawer');
  const drawerBg = $('#drawerBg');
  function openDrawer() { drawer?.classList.add('open'); drawer?.setAttribute('aria-hidden','false'); drawerBg?.classList.add('open'); document.body.style.overflow='hidden'; }
  function closeDrawer() { drawer?.classList.remove('open'); drawer?.setAttribute('aria-hidden','true'); drawerBg?.classList.remove('open'); document.body.style.overflow=''; }
  $('#cartBtn')?.addEventListener('click', e => { e.preventDefault(); openDrawer(); });
  $('#drawerClose')?.addEventListener('click', closeDrawer);
  drawerBg?.addEventListener('click', closeDrawer);

  // -------- Mobile menu (just-in-time) --------
  $('button[data-action="open-menu"]')?.addEventListener('click', () => {
    let m = $('#mMenu');
    if (!m) {
      m = document.createElement('aside');
      m.id = 'mMenu';
      m.className = 'm-menu drawer-like';
      // Use a.href (absolute URL) so the locale is already included by the browser
      m.innerHTML = `
        <button class="icon-btn" data-close style="margin-left:auto;margin-bottom:8px;">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>
        </button>
        ${$$('.nav a').map(a => `<a href="${a.href}">${a.textContent.trim()}</a>`).join('')}
      `;
      document.body.appendChild(m);
      m.querySelector('[data-close]').addEventListener('click', () => m.classList.remove('open'));
    }
    requestAnimationFrame(() => m.classList.add('open'));
  });

  // -------- Search overlay --------
  $('button[data-action="open-search"]')?.addEventListener('click', () => {
    window.location.href = localePath('/search');
  });

  // -------- Cart state via Shopify Ajax API --------
  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }});
    return res.ok ? res.json() : null;
  }
  async function addToCart(variantId, quantity = 1) {
    const res = await fetch(ROUTES.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity }] })
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
  }
  async function changeCart(key, quantity) {
    const res = await fetch(ROUTES.cart_change_url || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    return res.ok ? res.json() : null;
  }

  function updateCartUI(cart) {
    if (!cart) return;
    const count = $('#cartCount');
    if (count) { count.textContent = cart.item_count; count.style.display = cart.item_count > 0 ? 'flex' : 'none'; }
    const total = $('#drawerTotal');
    if (total) total.textContent = formatMoney(cart.items_subtotal_price || cart.total_price);
    const body = $('#drawerBody');
    if (body) {
      if (cart.items.length === 0) {
        body.innerHTML = `
          <div class="drawer-empty">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
            <p>Your cart is empty.</p>
          </div>`;
        return;
      }
      body.innerHTML = cart.items.map(item => {
        // item.url from Shopify API is like /products/xxx — add locale prefix
        const itemUrl = localePath(item.url);
        return `
        <div class="drawer-item" data-key="${item.key}">
          <a href="${itemUrl}">
            ${item.featured_image && item.featured_image.url
              ? `<img src="${item.featured_image.url}" alt="${escapeAttr(item.title)}">`
              : `<div style="width:72px;height:90px;background:var(--blush);border-radius:3px;"></div>`}
          </a>
          <div style="flex:1;">
            <div class="di-cat">${escapeHtml(item.product_type || 'Body Splash')} · 250ml</div>
            <a href="${itemUrl}" class="di-name" style="display:block;">${escapeHtml(item.product_title)}</a>
            <div class="di-price">${formatMoney(item.final_price)}</div>
            <div class="di-qty">
              <button type="button" data-act="dec" data-key="${item.key}">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-act="inc" data-key="${item.key}">+</button>
            </div>
          </div>
        </div>
      `}).join('');
    }
  }

  function escapeHtml(s){ return String(s||'').replace(/[&<>"']/g, c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c]); }
  function escapeAttr(s){ return escapeHtml(s); }

  // Drawer qty handlers
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('#drawerBody button[data-act]');
    if (!btn) return;
    const key = btn.dataset.key;
    const wrap = btn.closest('.drawer-item');
    const span = wrap?.querySelector('.di-qty span');
    const cur = span ? parseInt(span.textContent, 10) : 0;
    const next = btn.dataset.act === 'inc' ? cur + 1 : cur - 1;
    const cart = await changeCart(key, Math.max(0, next));
    updateCartUI(cart);
    bumpCartIcon();
  });

  // -------- Quick add + fly animation --------
  function bumpCartIcon() {
    const cartBtn = $('#cartBtn');
    cartBtn?.animate(
      [{ transform: 'scale(1)' }, { transform: 'scale(1.2)' }, { transform: 'scale(1)' }],
      { duration: 400 }
    );
  }

  async function flyToCart(originEl, variantId, imgSrc) {
    const cartBtn = $('#cartBtn');
    if (!cartBtn || !originEl) {
      try { const c = await addToCart(variantId, 1); const cart = await fetchCart(); updateCartUI(cart); openDrawer(); bumpCartIcon(); } catch(e){ console.error(e); }
      return;
    }
    const r1 = originEl.getBoundingClientRect();
    const r2 = cartBtn.getBoundingClientRect();
    const fly = document.createElement('img');
    fly.src = imgSrc;
    fly.className = 'fly';
    fly.style.left = r1.left + (r1.width - 60) / 2 + 'px';
    fly.style.top  = r1.top + 'px';
    document.body.appendChild(fly);
    requestAnimationFrame(() => {
      fly.style.left = r2.left + r2.width / 2 - 8 + 'px';
      fly.style.top  = r2.top + r2.height / 2 - 8 + 'px';
      fly.style.width = '16px';
      fly.style.height = '16px';
      fly.style.opacity = '0';
      fly.style.transform = 'rotate(20deg)';
    });
    try { await addToCart(variantId, 1); } catch(e){ console.error(e); fly.remove(); return; }
    setTimeout(async () => {
      fly.remove();
      const cart = await fetchCart();
      updateCartUI(cart);
      bumpCartIcon();
      openDrawer();
    }, 700);
  }

  // Wire up quick-add buttons globally
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('button[data-add-id]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const id = btn.dataset.addId;
    const img = btn.dataset.img || btn.closest('.product')?.querySelector('img')?.src || '';
    const origin = btn.closest('.product-img') || btn;
    flyToCart(origin, id, img);
  });

  // -------- Favorite toggle (visual only) --------
  document.addEventListener('click', e => {
    const fav = e.target.closest('[data-fav]');
    if (!fav) return;
    e.preventDefault();
    e.stopPropagation();
    fav.classList.toggle('saved');
  });

  // -------- Hero slider --------
  $$('[data-hero]').forEach(hero => {
    const slides = $$('.hero-slide', hero);
    if (slides.length < 2) return;
    const dots = $$('[data-hero-dots] span', hero);
    const interval = parseInt(hero.dataset.interval, 10) || 6000;
    const autoplay = hero.dataset.autoplay !== 'false';
    let cur = slides.findIndex(s => s.classList.contains('active'));
    if (cur < 0) cur = 0;

    function go(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('active', k === cur));
      dots.forEach((d, k) => d.classList.toggle('active', k === cur));
    }
    let timer = autoplay ? setInterval(() => go(cur + 1), interval) : null;
    function reset() { if (timer) { clearInterval(timer); timer = setInterval(() => go(cur + 1), interval); } }
    $('[data-hero-prev]', hero)?.addEventListener('click', () => { go(cur - 1); reset(); });
    $('[data-hero-next]', hero)?.addEventListener('click', () => { go(cur + 1); reset(); });
    dots.forEach(d => d.addEventListener('click', () => { go(+d.dataset.i); reset(); }));
  });

  // -------- PDP --------
  $$('.pdp-thumb').forEach(t => {
    t.addEventListener('click', () => {
      $$('.pdp-thumb').forEach(x => x.classList.remove('active'));
      t.classList.add('active');
      const img = $('#pdpMainImg');
      if (img) img.src = t.dataset.src;
    });
  });

  $$('[data-qty]').forEach(b => {
    b.addEventListener('click', () => {
      const input = b.parentElement.querySelector('input[name="quantity"]');
      if (!input) return;
      const cur = parseInt(input.value, 10) || 1;
      input.value = b.dataset.qty === 'inc' ? cur + 1 : Math.max(1, cur - 1);
    });
  });

  // PDP variant selector (option pills)
  $$('.pdp-option-value').forEach(btn => {
    btn.addEventListener('click', () => {
      const idx = parseInt(btn.dataset.optionIndex, 10);
      const value = btn.dataset.optionValue;
      btn.parentElement.querySelectorAll('.pdp-option-value').forEach(x => x.classList.remove('active'));
      btn.classList.add('active');
      const product = window.productData;
      if (!product) return;
      const selectedValues = [];
      $$('.pdp-option').forEach((opt, i) => {
        const active = opt.querySelector('.pdp-option-value.active');
        selectedValues[i] = active ? active.dataset.optionValue : null;
      });
      const variant = product.variants.find(v =>
        selectedValues.every((val, i) => !val || v.options[i] === val)
      );
      if (variant) {
        const sel = $('#variantSelect');
        if (sel) sel.value = variant.id;
        const priceEl = $('.pdp-price');
        if (priceEl) {
          priceEl.innerHTML = (variant.compare_at_price > variant.price
            ? `<span class="was">${formatMoney(variant.compare_at_price)}</span>` : '')
            + formatMoney(variant.price);
        }
        const addBtn = $('.pdp-add');
        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? 'Add to Cart →' : 'Sold Out';
        }
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    });
  });

  // -------- Cart page line update --------
  $$('.cart-qty-control button[data-act]').forEach(b => {
    b.addEventListener('click', async () => {
      const wrap = b.closest('.cart-qty-control');
      const input = wrap.querySelector('input[type="number"]');
      const cur = parseInt(input.value, 10) || 1;
      const next = b.dataset.act === 'inc' ? cur + 1 : Math.max(0, cur - 1);
      input.value = next;
      const cart = await changeCart(wrap.dataset.key, next);
      updateCartUI(cart);
      window.location.reload();
    });
  });
  $$('.cart-item-remove').forEach(b => {
    b.addEventListener('click', async () => {
      await changeCart(b.dataset.key, 0);
      window.location.reload();
    });
  });

  // -------- Collection sort --------
  $('[data-sort]')?.addEventListener('change', (e) => {
    const url = new URL(window.location);
    url.searchParams.set('sort_by', e.target.value);
    window.location = url.toString();
  });

  // -------- Initial cart fetch (sync with server) --------
  if (typeof fetch === 'function' && drawer) {
    fetchCart().then(updateCartUI).catch(() => {});
  }
})();